import type { SportTypeGroup, SportTypeItem } from '../api/sportTypes';

export const LOCAL_SPORT_TYPES: SportTypeItem[] = [
  { id: 1, name: 'Хоккей', emoji: '🏒', launchPriority: 1, hasDemoSchool: true },
  { id: 7, name: 'Плавание', emoji: '🏊', launchPriority: 1, hasDemoSchool: true },
  { id: 13, name: 'Футбол', emoji: '⚽', launchPriority: 1, hasDemoSchool: true },
  { id: 20, name: 'Бокс', emoji: '🥊', launchPriority: 1, hasDemoSchool: true },
  { id: 32, name: 'Гимнастика', emoji: '🤸', launchPriority: 1, hasDemoSchool: true },
  { id: 55, name: 'Танцы', emoji: '💃', launchPriority: 2 },
  { id: 60, name: 'Йога', emoji: '🧘', launchPriority: 2 },
  { id: 36, name: 'Теннис', emoji: '🎾', launchPriority: 2 },
  { id: 14, name: 'Баскетбол', emoji: '🏀', launchPriority: 2 },
  { id: 23, name: 'Дзюдо', emoji: '🥋', launchPriority: 2 },
];

export function buildLocalSportTypeGroups(demoOnly = false): SportTypeGroup[] {
  const sports = demoOnly
    ? LOCAL_SPORT_TYPES.filter((s) => s.hasDemoSchool)
    : LOCAL_SPORT_TYPES;
  return [
    {
      groupId: 0,
      groupName: 'Popular',
      groupEmoji: '🏆',
      sports,
    },
  ];
}
